<template>
  <div>
    <v-dialog v-if="!inline" v-model="dialogModel" :max-width="560" :fullscreen="$vuetify.breakpoint.xsOnly"
      content-class="product-order-dialog" persistent transition="dialog-transition" @input="onDialogInput">
      <v-card class="product-order-dialog__card">
        <v-card-title class="product-order-dialog__title">
          {{ $t("message.productsPageProductOrderButton") }}
        </v-card-title>
        <v-divider />
        <v-card-text class="product-order-dialog__content">
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-row v-if="isAuth && changeData" class="mb-2">
              <v-col cols="12">
                <v-btn small outlined @click="pushChangeContent">Изменить</v-btn>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-text-field v-model="name_org" :counter="50" :rules="name_orgRules" :label="name_orgLabelComputed"
                  class="inputStyle" prepend-inner-icon="house" required outlined />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-text-field v-model="adress" :label="adressLabelComputed" class="inputStyle"
                  prepend-inner-icon="place" outlined />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-text-field v-model="email" :label="emailLabelComputed" :rules="emailRules" class="inputStyle"
                  prepend-inner-icon="alternate_email" outlined />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <VuePhoneNumberInput v-model="phone" v-on:update="updatePhone" v-bind:translations="myTranslation"
                  class="mt-0" />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-checkbox v-model="privacyAccepted" :rules="[v => !!v || 'Обязательное поле']" hide-details="auto"
                  class="mt-0 pt-0" color="#0167b2">
                  <template #label>
                    <span style="font-size: 14px;">
                      {{ $t('message.privacyConsentPrefix') }}<a href="/file/acceptance_policy_smp.docx" target="_blank"
                        rel="noopener noreferrer" style="color: #0167b2; text-decoration: underline;" @click.stop>{{
                          $t('message.privacyConsentLink') }}</a>
                    </span>
                  </template>
                </v-checkbox>
                <div class="mt-3 mb-4" style="font-size: 12px; color: rgba(0,0,0,0.6); line-height: 1.2;">
                  {{ $t('message.privacyPolicyPrefix') }}<a href="/file/privacy_policy_smp.docx" target="_blank"
                    rel="noopener noreferrer" style="color: #0167b2; text-decoration: underline;" @click. stop>{{
                      $t('message.privacyPolicyLink') }}</a>{{ $t('message.privacyPolicyAnd') }}<a
                    href="/file/cookie_policy_smp.docx" target="_blank" rel="noopener noreferrer"
                    style="color: #0167b2; text-decoration: underline;" @click.stop>{{
                      $t('message.cookiePolicyLink') }}
                  </a>
                </div>
              </v-col>
            </v-row>
            <v-row class="product-order-dialog__actions">
              <v-col cols="12" class="d-flex flex-column flex-sm-row flex-wrap">
                <v-btn class="px-8 mr-sm-2 mb-2 mb-sm-0" color="light-blue darken-4" depressed outlined
                  :loading="loading" :disabled="!valid" @click="send">
                  {{ $t("message.partnershipForSuppliersForm10") }}
                </v-btn>
                <v-btn outlined color="grey darken-1" @click="close">
                  {{ $t("message.productOrderDialogCancel") }}
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Inline mode: only the form card (for admin change content page) -->
    <v-card v-else class="product-order-dialog__card">
      <v-card-title class="product-order-dialog__title">
        {{ $t("message.productsPageProductOrderButton") }}
      </v-card-title>
      <v-divider />
      <v-card-text class="product-order-dialog__content">
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-row>
            <v-col cols="12">
              <v-text-field :label="name_orgLabelComputed" class="inputStyle" outlined disabled />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-text-field :label="adressLabelComputed" class="inputStyle" outlined disabled />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-text-field :label="emailLabelComputed" class="inputStyle" outlined disabled />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-text-field :label="phoneLabelComputed" class="inputStyle" outlined disabled></v-text-field>
              />
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>

    <!-- Success dialog (sibling to avoid nested dialog issues) -->
    <v-dialog v-if="!inline" v-model="dialogSuccess" width="300" persistent content-class="product-order-dialog__toast">
      <v-card>
        <v-card-text class="pt-6 pb-8 circle-check">
          <i class="material-icons mr-5 mt-3 ml-2 success-icon">check_circle</i>
          <p>{{ $t("message.partnershipForSuppliersForm13") }}</p>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Error dialog -->
    <v-dialog v-if="!inline" v-model="dialogError" width="300" persistent content-class="product-order-dialog__toast">
      <v-card>
        <v-card-text class="pt-6 pb-8 circle-check">
          <i class="material-icons mr-5 mt-3 ml-2 error-icon">cancel</i>
          <p>{{ $t("message.partnershipForSuppliersForm14") }}</p>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import VuePhoneNumberInput from "vue-phone-number-input";

export default {
  name: "ProductOrderFormDialog",
  components: { VuePhoneNumberInput },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    name_orgLabel: { type: String, default: "" },
    adressLabel: { type: String, default: "" },
    emailLabel: { type: String, default: "" },
    phoneLabel: { type: String, default: "" },
    id_name_orgLabel: { type: [Number, String], default: undefined },
    id_adressLabel: { type: [Number, String], default: undefined },
    id_emailLabel: { type: [Number, String], default: undefined },
    id_phoneLabel: { type: [Number, String], default: undefined },
    change: { type: Boolean, default: undefined },
    /** When true, render only the form card (no dialog), for admin change content page */
    inline: { type: Boolean, default: false },
  },
  data() {
    const defaultNameOrg = this.$t("message.partnershipForSuppliersForm1");
    const defaultAdress = this.$t("message.partnershipForSuppliersForm2");
    const defaultEmail = this.$t("message.partnershipForSuppliersForm3");
    const defaultPhone = this.$t("message.partnershipForSuppliersForm7");
    const _name_org = this.getT18nData(
      this.name_orgLabel || defaultNameOrg,
      this.id_name_orgLabel,
    );
    const _adress = this.getT18nData(
      this.adressLabel || defaultAdress,
      this.id_adressLabel,
    );
    const _email = this.getT18nData(
      this.emailLabel || defaultEmail,
      this.id_emailLabel,
    );
    const _phone = this.getT18nData(
      this.phoneLabel || defaultPhone,
      this.id_phoneLabel,
    );
    const idList = [
      this.id_name_orgLabel,
      this.id_adressLabel,
      this.id_emailLabel,
      this.id_phoneLabel,
    ].filter((id) => id !== undefined && id !== null);
    const self = this;
    if (idList.length) {
      this.$store
        .dispatch("contentChanges/GET_CONTENT", { id_list: idList })
        .then(() => {
          const content = this.$store.getters["contentChanges/content"] || [];
          content.forEach((c) => {
            const id = parseInt(c.id_content);
            if (id === parseInt(self.id_name_orgLabel)) {
              _name_org.value_rus = c.value_rus;
              _name_org.value_eng = c.value_eng;
            }
            if (id === parseInt(self.id_adressLabel)) {
              _adress.value_rus = c.value_rus;
              _adress.value_eng = c.value_eng;
            }
            if (id === parseInt(self.id_emailLabel)) {
              _email.value_rus = c.value_rus;
              _email.value_eng = c.value_eng;
            }
            if (id === parseInt(self.id_phoneLabel)) {
              _phone.value_rus = c.value_rus;
              _phone.value_eng = c.value_eng;
            }
          });
        });
    }
    return {
      name_orgLabelData: _name_org,
      adressLabelData: _adress,
      emailLabelData: _email,
      phoneLabelData: _phone,
      valid: true,
      name_org: "",
      adress: "",
      email: "",
      phone: "",
      privacyAccepted: false,
      /** URL файла/страницы политики конфиденциальности — замените на свой путь при добавлении файла */
      privacyPolicyUrl: "/file/privacy_policy_smp.pdf",
      name_orgRules: [
        (v) => !!v || "Обязательное поле",
        (v) =>
          (v && v.length <= 50) ||
          "Название организации должно содержать не более 50 символов",
      ],
      emailRules: [
        (v) => !!v || "Обязательное поле",
        (v) =>
          /.+@.+\..+/.test(v) || "Электронная почта должна быть действительной",
      ],
    };
  },
  computed: {
    isAuth() {
      return this.$store.getters["adminAuth/checkAuth"];
    },
    changeData() {
      if (this.change === false) return false;
      const hasIds =
        this.id_name_orgLabel ||
        this.id_adressLabel ||
        this.id_emailLabel ||
        this.id_phoneLabel;
      return !!hasIds;
    },
    name_orgLabelComputed() {
      if (
        this.name_orgLabelData &&
        (this.name_orgLabelData.value_rus || this.name_orgLabelData.value_eng)
      ) {
        return this.$i18n.locale === "ru"
          ? this.name_orgLabelData.value_rus
          : this.name_orgLabelData.value_eng;
      }
      return this.$t("message.partnershipForSuppliersForm1");
    },
    adressLabelComputed() {
      if (
        this.adressLabelData &&
        (this.adressLabelData.value_rus || this.adressLabelData.value_eng)
      ) {
        return this.$i18n.locale === "ru"
          ? this.adressLabelData.value_rus
          : this.adressLabelData.value_eng;
      }
      return this.$t("message.partnershipForSuppliersForm2");
    },
    emailLabelComputed() {
      if (
        this.emailLabelData &&
        (this.emailLabelData.value_rus || this.emailLabelData.value_eng)
      ) {
        return this.$i18n.locale === "ru"
          ? this.emailLabelData.value_rus
          : this.emailLabelData.value_eng;
      }
      return this.$t("message.partnershipForSuppliersForm3");
    },
    phoneLabelComputed() {
      if (
        this.phoneLabelData &&
        (this.phoneLabelData.value_rus || this.phoneLabelData.value_eng)
      ) {
        return this.$i18n.locale === "ru"
          ? this.phoneLabelData.value_rus
          : this.phoneLabelData.value_eng;
      }
      return this.$t("message.partnershipForSuppliersForm7");
    },
    privacyRules() {
      return [
        (v) =>
          !!v || this.$t("message.productOrderDialogPrivacyError"),
      ];
    },
    dialogModel: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    loading() {
      return this.$store.state.mail.requestFormLoading;
    },
    dialogSuccess: {
      get() {
        return this.$store.state.mail.requestFormLoad;
      },
      set() {
        this.resetForm();
        this.$store.dispatch("mail/HIDE_FORM", "requestFormLoad");
        this.dialogModel = false;
      },
    },
    dialogError: {
      get() {
        return this.$store.state.mail.requestFormError;
      },
      set() {
        this.$store.dispatch("mail/HIDE_FORM", "requestFormError");
      },
    },
    myTranslation() {
      let phoneNumberLabel = this.$t("message.partnershipForSuppliersForm7");
      if (
        this.phoneLabelData &&
        (this.phoneLabelData.value_rus || this.phoneLabelData.value_eng)
      ) {
        phoneNumberLabel =
          this.$i18n.locale === "ru"
            ? this.phoneLabelData.value_rus
            : this.phoneLabelData.value_eng;
      }
      return {
        countrySelectorLabel: this.$t("message.partnershipForSuppliersForm6"),
        countrySelectorError: this.$t(
          "message.partnershipForSuppliersForm6Error",
        ),
        phoneNumberLabel,
        example: this.$t("message.partnershipForSuppliersForm7Example"),
      };
    },
  },
  methods: {
    getT18nData(i18n_data, id_content) {
      if (i18n_data === "") {
        return { value_rus: i18n_data, value_eng: i18n_data, id_content };
      }
      const ru = Object.entries(this.$i18n.messages.ru.message).find(
        ([, v]) => v === i18n_data,
      );
      if (ru) {
        return {
          value_rus: this.$i18n.messages.ru.message[ru[0]],
          value_eng: this.$i18n.messages["en-US"].message[ru[0]],
          id_content,
        };
      }
      const en = Object.entries(this.$i18n.messages["en-US"].message).find(
        ([, v]) => v === i18n_data,
      );
      if (en) {
        return {
          value_rus: this.$i18n.messages.ru.message[en[0]],
          value_eng: this.$i18n.messages["en-US"].message[en[0]],
          id_content,
        };
      }
      return { value_rus: i18n_data, value_eng: i18n_data, id_content };
    },
    pushChangeContent() {
      const content_to_change = {
        name_orgLabel: this.name_orgLabelData,
        adressLabel: this.adressLabelData,
        emailLabel: this.emailLabelData,
        phoneLabel: this.phoneLabelData,
      };
      this.$store.dispatch("contentChanges/SET_CONTENT_TO_CHANGE", {
        type_to_change: "ProductOrderFormDialog",
        content_to_change,
      });
      this.$router.push("/change_content");
    },
    updatePhone() { },
    onDialogInput(val) {
      if (!val) {
        this.resetForm();
      }
    },
    close() {
      this.dialogModel = false;
    },
    resetForm() {
      this.name_org = "";
      this.adress = "";
      this.email = "";
      this.phone = "";
      this.privacyAccepted = false;
      this.$refs.form && this.$refs.form.resetValidation();
    },
    validateForm() {
      if (!this.name_org || this.name_org.length > 50) return false;
      if (!this.email || !/.+@.+\..+/.test(this.email)) return false;
      if (!this.privacyAccepted) return false;
      return true;
    },
    send() {
      if (!this.$refs.form.validate()) return;
      if (!this.validateForm()) {
        this.$store.dispatch("mail/SHOW_REQUESTERROR");
        return;
      }
      this.$store.dispatch("mail/SEND_REQUESTFORM", {
        name_org: this.name_org,
        adress: this.adress,
        phone: this.phone,
        email: this.email,
        request_type: "",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.product-order-dialog__card {
  border-radius: 8px;
  box-shadow:
    0 11px 15px -7px rgba(0, 0, 0, 0.2),
    0 24px 38px 3px rgba(0, 0, 0, 0.14),
    0 9px 46px 8px rgba(0, 0, 0, 0.12);
}

.product-order-dialog__title {
  color: #1976d2 !important;
  font-weight: 600;
  font-size: 1.25rem;
  padding: 20px 24px 16px;
  word-break: break-word;
}

.product-order-dialog__content {
  margin-top: 16px;
  padding: 16px 24px 24px;
}

.product-order-dialog__actions {
  margin-top: 46px;
}

.product-order-dialog__privacy-checkbox {
  margin-top: 8px;
}

.product-order-dialog__privacy-link {
  color: #1976d2;
  text-decoration: underline;
}

.product-order-dialog__privacy-link:hover {
  text-decoration: underline;
}

.success-icon {
  color: #00c853 !important;
  font-size: 48px;
}

.error-icon {
  color: #ff5252 !important;
  font-size: 48px;
}

@media screen and (max-width: 600px) {
  .product-order-dialog__title {
    padding: 16px 16px 12px;
    font-size: 1.1rem;
  }

  .product-order-dialog__content {
    margin-top: 12px;
    padding: 12px 16px 20px;
  }
}
</style>

<style lang="scss">
.product-order-dialog {
  &.v-dialog--fullscreen {
    .product-order-dialog__card {
      border-radius: 0;
    }
  }
}

.product-order-dialog__toast {
  .circle-check>p {
    margin-top: -40px;
    margin-left: 80px;
  }
}
</style>
